module.exports = __webpack_public_path__ + "img/20241112142639.12ed4bcc.png";